import { Directive, OnChanges, Input, Renderer2, ElementRef, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[attributes]',
    standalone: true,
})
export class AttributeDirective implements OnChanges {

    @Input()
    public attributes: { [key: string]: any };

    constructor(
        private renderer: Renderer2,
        private elementRef: ElementRef
    ) { }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.attributes) {
            if (typeof changes.attributes.currentValue != 'string') {
                for (const attributeName in this.attributes) {
                    if (this.attributes.hasOwnProperty(attributeName)) {
                        const attributeValue = this.attributes[attributeName];
                        if (attributeValue != null) {
                            this.renderer.setAttribute(this.elementRef.nativeElement, attributeName, attributeValue);
                        } else {
                            this.renderer.removeAttribute(this.elementRef.nativeElement, attributeName);
                        }
                    }
                }
            } else {
                const attrName = changes.attributes.currentValue;
                this.renderer.setAttribute(this.elementRef.nativeElement, attrName, '');
            }
        }
    }
}
